import { S3DocsBrowser } from "../hrpDocs/HrpDocs"
import { fetchFinanceDoc, fetchFinanceDocBinary, fetchFinanceDocs } from "../../utils/apiUtils"

const FinanceDocs = () => (
    <S3DocsBrowser
        title="Finance Docs"
        basePath="/finance/docs"
        queryKey="finance-docs"
        fetchList={fetchFinanceDocs}
        fetchFile={fetchFinanceDoc}
        fetchBinary={fetchFinanceDocBinary}
        keyPrefix=""
        listError="Could not load finance docs."
    />
)

export default FinanceDocs
